import * as React from "react";
import { Component } from "react";
import { ButtonDropdown, DropdownItem, DropdownMenu, DropdownToggle } from "reactstrap";

interface StateDropdownProps {
  state: string;

  onChange(state: string): void;

  className?: string;
  group?: boolean;
  color?: string;
  displayExcluded?: boolean;
}

interface StateDropdownState {
  ddOpen: boolean;
}

export default class StateDropdown extends Component<StateDropdownProps, StateDropdownState> {
  constructor(props: StateDropdownProps) {
    super(props);

    this.state = {
      ddOpen: false,
    };
  }

  toggle() {
    this.setState({
      ddOpen: !this.state.ddOpen,
    });
  }

  onClickState(state: string) {
    this.props.onChange(state);
  }

  render() {
    return (
      <ButtonDropdown
        group={this.props.group}
        className={this.props.className}
        isOpen={this.state.ddOpen}
        toggle={this.toggle.bind(this)}
      >
        <DropdownToggle caret color={this.props.color}>
          {this.props.state === "validated" && <i className="fa fa-check" title="validated" />}
          {this.props.state === "doubt" && <i className="fa fa-question" title="doubt" />}
          {this.props.state === "proposal" && <i className="fa fa-tag" title="proposal" />}
          {this.props.state === "excluded" && <i className="fa fa-thumbs-down" title="excluded" />}
        </DropdownToggle>
        <DropdownMenu>
          <DropdownItem onClick={(evt: any) => this.onClickState("validated")}>
            <i className="fa fa-check" />
            &nbsp;Valider
          </DropdownItem>
          <DropdownItem onClick={(evt: any) => this.onClickState("doubt")}>
            <i className="fa fa-question" />
            &nbsp;Doute
          </DropdownItem>
          <DropdownItem onClick={(evt: any) => this.onClickState("proposal")}>
            <i className="fa fa-tag" />
            &nbsp;Proposal
          </DropdownItem>
          {this.props.displayExcluded && (
            <DropdownItem onClick={(evt: any) => this.onClickState("excluded")}>
              <i className="fa fa-thumbs-down" />
              &nbsp;Excluded
            </DropdownItem>
          )}
        </DropdownMenu>
      </ButtonDropdown>
    );
  }
}
